import {membershipCard} from '../../../types';

export const trackMembership = ({
  action,
  card,
}: {
  action: 'add' | 'remove';
  card: membershipCard;
}) => {
  const event = {
    event: 'orderMembershipCard',
    action: action,
    label: null,
    value: null,
    card: card,
  };

  return event;
};
